import { IconClassKey } from "@mui/material";
import { Component } from "react";
import { ConditionalStyles, TableColumn } from "react-data-table-component";
import DataGrid from "../../Components/DataGrid/DataGrid";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import FormServices from "../../Services/FormServices";
import { IPopoverItemData } from "../../Components/DataGrid/Plugins/CustomMaterialMenu/Interface";
import CustomMaterialMenu from "../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
import { ShowBlocker } from "../../Components/LoaderComponent/LoaderComponent";
import ProfileServices from "../../Services/ProfileServices";
import { ShowAlert } from "../../Components/ShowAlert";

export interface IClaim {
    userId: string,
    taxYear: number,
    returnFilingDate: string,
    filingStatus: string,
    totalClaim: number,
    netFtp: number,
    netFtf: number,
    netInterest: number,
    net6654: number,
    ftpClaim: number,
    ftfClaim: number,
    interestClaim: number,
    claim6654: number,
    isReviewRequired: string,
    isReviewApproved: number,
    htmlTranscript: string
}

export interface IAuthorizedUser {
    userId: string,
    userName: string,
    email: string,
    claims: IClaim[],
    phoneNumber: string,
    paymentStatus: string,
    isReviewRequired: string,
    totalClaim: number
}

interface IAuthorizedUserState {
    subList: IAuthorizedUser[]
    accessToken: string,
    currentPage: number,
    currentRowsPerPage: number,
    searchText: string,
    totalRows: 0,
    currentSortColumn: string,
    sortingDirection: string,
    subject: string,
    body: string,
}

interface IClaimProps {
    claims: IClaim[];
    accessToken: string;
    refreshCallBack: () => void;
}

class PaymentTable extends Component<IClaimProps, {}> {
    constructor(props: IClaimProps) {
        super(props);
    }

    private kwongClaimColumns: TableColumn<IClaim>[] = [
        { name: 'Tax Year', selector: row => row.taxYear, },
        { name: 'Filing Status', selector: row => row.filingStatus, },

        { name: 'Net FTP', selector: row => `$${row.netFtp}`, },
        { name: 'Net FTF', selector: row => `$${row.netFtf}`, },
        { name: 'Net Interest', selector: row => `$${row.netInterest}`, },
        { name: 'Net 6654', selector: row => `$${row.net6654}`, },
        { name: 'FTP Claim', selector: row => `$${row.ftpClaim}`, },
        { name: 'FTF Claim', selector: row => `$${row.ftfClaim}`, },
        { name: 'Interest Claim', selector: row => `$${row.interestClaim}`, },
        { name: 'Claim 6654', selector: row => `$${row.claim6654}`, },

        { name: 'Total Claim', selector: row => `$${row.totalClaim}`, },

        {
            cell: (row) => {
                let menu: IPopoverItemData[] = [
                    {
                        key: "download",
                        label: "Download Transcript"
                    },
                    {
                        key: "download843",
                        label: "Download Form-843"
                    }
                ];
                if (row.isReviewRequired === 'Yes' && !(row.isReviewApproved === 1)) {
                    menu.push(
                        {
                            key: "approve",
                            label: "Approve"
                        }
                    )
                }

                return <CustomMaterialMenu
                    fontSize="small"
                    multiPopoverItems={menu}
                    onPopoverClick={(key_: string, label_: string) => {
                        if (key_ == "download") {
                            this.openHtmlAsPdf(row.htmlTranscript, row.taxYear);
                        }
                        if (key_ == "approve") {
                            this.handleStatusUpdate(row);
                        }
                    }}
                />
            },
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ];

    conditionalRowStyles: ConditionalStyles<IClaim>[] = [
        {
            when: (row) => row.isReviewRequired === 'Yes' && !(row.isReviewApproved === 1),
            style: {
                backgroundColor: "#ffeb3b"
            },
        },
    ];

    openHtmlAsPdf = (htmlString: string, taxYear: number) => {
        const element = document.createElement('div');
        element.innerHTML = htmlString;

        const options = {
            margin: 10,
            filename: `transcript_${taxYear}.pdf`,
            image: { type: 'jpeg' as const, quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm' as const, format: 'a4' as const, orientation: 'portrait' as const }
        };

        html2pdf()
            .set(options)
            .from(element)
            .outputPdf('bloburl')
            .then((pdfUrl: any) => {
                window.open(pdfUrl, '_blank');
            });
    };

    handleStatusUpdate(row: IClaim) {

        Swal.fire({
            title: `Approve Kwong Payment`,
            html: `
                <div style="text-align: left;">
                    <p>Are you sure you want to <strong>Approve</strong> the kwong payment for the tax year - ${row.taxYear}</p>                    
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Approve',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateKwongPaymentReviewStatus(row.userId, row.taxYear);
            }
        });
    }

    updateKwongPaymentReviewStatus(userId: string, taxYear: number) {
        const requestData = {
            userId: userId,
            taxYear: taxYear
        };

        ShowBlocker(true);

        FormServices.updateKwongPaymentReviewStatus(requestData, this.props.accessToken).then(r => {
            ShowBlocker(false);
            if (r.ok) {
                r.json().then(response => {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Kwong payment has been Approved successfully.`,
                    }).then(() => {
                        // Refresh the data after successful update
                        //this.props.refreshCallBack();
                        window.location.reload();
                    });
                })
            }
        });
    }


    render() {
        return (
            <DataGrid
                title='Payment Details'
                columns={this.kwongClaimColumns}
                data={this.props.claims}
                pagination
                paginationTotalRows={this.props.claims?.length}
                // conditionalRowStyles={this.conditionalRowStyles}
            />
        );
    }
}

class KwongClaim extends Component<{}, IAuthorizedUserState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            subList: [],
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: '',
            body: '',
            subject: ''
        }
    }

    private formColumns: TableColumn<IAuthorizedUser>[] = [

        {
            name: 'Taxpayer Name',
            selector: (row: IAuthorizedUser) => row.userName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IAuthorizedUser) => row.email,
            sortable: true,
        },
        {
            name: 'Mobile',
            selector: (row: IAuthorizedUser) => row.phoneNumber,
            sortable: false,
        },
        {
            name: 'Total Claim',
            selector: (row: IAuthorizedUser) => `$${row.totalClaim}`,
            sortable: true,
            right: true
        },
        {
            name: 'Payment Status',
            selector: (row: IAuthorizedUser) => row.paymentStatus,
            sortable: true
        },
        {
            name: 'Review Required',
            selector: (row: IAuthorizedUser) => row.isReviewRequired,
            sortable: true
        },
        {
            cell: (row) => {
                let menu: IPopoverItemData[] = [
                    {
                        key: "sendEmail",
                        label: "Send Email"
                    }
                ];

                return <CustomMaterialMenu
                    fontSize="small"
                    multiPopoverItems={menu}
                    onPopoverClick={(key_: string, label_: string) => {

                        if (key_ == "sendEmail") {
                            this.sendEmail(row.userId);
                        }
                    }}
                />
            },
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ];

    // conditionalRowStyles: ConditionalStyles<IAuthorizedUser>[] = [
    //     {
    //         when: (row) => row.claims.some((item) => item.isReviewRequired === 'Yes' && !(item.isReviewApproved === 1)),
    //         style: {
    //             backgroundColor: "#ffeb3b"
    //         },
    //     },
    // ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getAllKwongClaims();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }


    getAllKwongClaims() {
        let postData = {
            sort: {
                column: this.state.currentSortColumn,
                direction: this.state.sortingDirection
            },
            limit: this.state.currentRowsPerPage,
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            searchFilter: this.state.searchText
        };
        FormServices.getAllKwongClaims(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    this.setState({ subList: response.data, totalRows: response.totalCount });
                })
            }
        });
    }


    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
            case "Payment Status":
                actualColName = 'paymentStatus';
                break;
            case "Review Required":
                actualColName = 'isReviewRequired';
                break;
            case "Total Claim":
                actualColName = 'totalClaim';
                break;
        }
        return actualColName;
    }

    sendEmail = async (userId: string) => {

        const { subject, body } = this.state;
        const result = await Swal.fire({
            title: "Send Email",
            html: `
        <input 
          id="swal-subject" 
          class="swal2-input" 
          placeholder="Enter Subject"
          value="${subject}"
        
        />

        <textarea 
          id="swal-body" 
          class="swal2-textarea" 
          placeholder="Enter Email Body"
        >${body}</textarea>
      `,
            showCancelButton: true,
            confirmButtonText: "Send",

            didOpen: () => {

                const subjectInput = document.getElementById("swal-subject");
                const bodyInput = document.getElementById("swal-body");

                subjectInput?.addEventListener("input", (e) => {
                    this.setState({
                        subject: (e.target as HTMLInputElement).value
                    });
                });

                bodyInput?.addEventListener("input", (e) => {
                    this.setState({
                        body: (e.target as HTMLTextAreaElement).value
                    });
                });
            },

            preConfirm: () => {

                if (!this.state.subject || !this.state.body) {
                    Swal.showValidationMessage(
                        "Subject and Body are required"
                    );
                    return false;
                }

                return true;
            }
        });

        if (result.isConfirmed) {

            const payload = {
                userId: userId,
                emailSubject: this.state.subject,
                emailBody: this.state.body
            };

            ProfileServices.sendCustomEmail(payload, this.state.accessToken).then(r => {
                if (r.ok) {
                    r.json().then(response => {
                        ShowAlert("Success", "Email sent successfully", "success").then(r => {
                            this.getAllKwongClaims();
                        });
                    });
                }
            });

            this.setState({
                subject: "",
                body: ""
            });
        }
    };

    public render() {

        const ExpandedComponent = ({ data }: { data: IAuthorizedUser }) => (
            <div style={{ padding: '10px', background: '#f9f9f9' }}>
                <PaymentTable claims={data.claims} accessToken={this.state.accessToken} refreshCallBack={this.getAllKwongClaims} />
            </div>
        );
        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Kwong Claim Details'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.subList}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}

                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    expandableRows
                    expandedComponent={ExpandedComponent}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                    // conditionalRowStyles={this.conditionalRowStyles}
                />
            </div>
        )
    }

}
export default KwongClaim;
